<div class="relay-board">
  <div class="container" *ngIf="!isError">
    <div class="row">
      <div class="col-sm-3" *ngFor="let relay of state">
        <div class="btn mt-3"
             [textContent]="'Relay' + (relay.id+1)"
             [ngClass]="relay.enabled ? 'btn-danger' : 'btn-light'"
             (click)="toggleRelay(relay.id)"></div>
      </div>
    </div>
    <div class="text-center mt-3 mb-3">
      <button type="button" class="btn btn-primary" [disabled]="loading || isNoChanges()" (click)="setState()">Update state</button>
      <button type="button" class="btn btn-secondary ml-3" [disabled]="loading || isNoChanges()" (click)="updateState()">Reset</button>
    </div>
    <ng-template #emptyLoadingTemplate></ng-template>
    <ngx-loading
      [show]="loading"
      [config]="{
        primaryColour: primaryColour,
        secondaryColour: secondaryColour,
        tertiaryColour: primaryColour,
        backdropBorderRadius: '3px'
      }"
      [template]="emptyLoadingTemplate"></ngx-loading>
  </div>
  <div *ngIf="isError">Relay device is unavailable</div>
</div>
